import { useState } from "react";
import { Wrapper } from "./UserList.style";
import WalletUserSearch from "./WalletUserSearch/WalletUserSearch";
import WalletUserDetail from "./WalletUserDetail/WalletUserDetail";
import { PaginationBox } from "components/Pagination/PaginationBox";

// 회원검색 :: (http://localhost:3000/manage/user/wallet)
const WalletUser = () => {
  const [userList, setUserMoveList] = useState([]);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [searchData, setSearchData] = useState({});
  const [isSearch, setIsSearch] = useState(false);

  return (
    <Wrapper>
      <div>
        <WalletUserSearch
          setUserMoveList={setUserMoveList}
          setPage={setPage}
          currentPage={page}
          pageSize={size}
          setSearchData={setSearchData}
          searchData={searchData}
          setIsSearch={setIsSearch}
        />

        <WalletUserDetail
          userList={userList}
          setPage={setPage}
          setSize={setSize}
          searchData={searchData}
          isSearch={isSearch}
        />

        {!!userList.length && (
          <PaginationBox
            totalItemsCount={userList[0]?.cnt}
            page={page}
            setPage={setPage}
            size={size}
          />
        )}
      </div>
    </Wrapper>
  );
};

export default WalletUser;
